import SimpplrSites from './SimpplrSites'

export default SimpplrSites
